export default __webpack_public_path__ + "static/media/logo_website.66af40da.png";